import { getApi } from '../../components/Shared/shared';
const baseURL = getApi();

export const menuItemsUrl = {
  menuItems: `${baseURL}/menu-items`
};

export default menuItemsUrl;
